export class ImageBaseRefFactory {
    static create(imageBaseRef: IBaseImageRef): IContentAPIImageBaseRef {
        return new ImageBaseRef(imageBaseRef).serialize();
    }
}

export class ImageBaseRef {
    protected _uri: string;
    protected _tags?: Array<string>;

    constructor(imageBaseRef: IBaseImageRef) {
        this._uri = imageBaseRef.uri;
        this._tags = imageBaseRef.tags;
    }

    serialize(): IContentAPIImageBaseRef {
        const imageRef: IContentAPIImageBaseRef = {
            uri: this._uri
        };

        if (this._tags !== undefined) {
            imageRef.tags = this._tags;
        }

        return imageRef;
    }
}

export interface IContentAPIImageBaseRef {
    uri: string;
    tags?: Array<string>;
}